import { getDictPhrase } from "../../../common";
export const getEachWayTitleInfo = (selection, state) => `(${getDictPhrase(state.dict, "EachWay")} ${selection.eachWayOdds || ""} ${getEachWayPlaces(selection)})`;
const getEachWayPlaces = (selection) => {
    if (selection.eachWayPlaces && selection.eachWayPlaces >= 2) {
        let places = "1-2";
        for (let i = 3; i <= selection.eachWayPlaces; i++) {
            places += `-${i}`;
        }
        return places;
    }
    return "";
};
//# sourceMappingURL=getEachWayTitleInfo.js.map